import Mmenu from 'mmenu-js';
import 'mburger-webcomponent/dist/mburger/index';

export default function initializeMobileMenu() {
    const menu = new Mmenu( '#mobile-menu', {
        theme          : 'white',
        offCanvas      : {position	: "bottom"},
        close          : true,
    } );

    const menuItems = document.querySelectorAll('.menu__link');
    menuItems.forEach(function (item) {
        item.addEventListener('click', function () {
            const api = menu.API;
            api.close();
        });
    });
    initializeDesktopMenuSubmenus();
}

/**
 * Rozwijanie/zwijanie podmenu – tym samym elementem (span lub przycisk przy linku), WCAG 2.1 AA
 */
function initializeDesktopMenuSubmenus() {
    const nav = document.querySelector( '.main-menu' );
    if ( ! nav ) return;

    const labelExpand = 'Rozwiń podmenu dla ';
    const labelCollapse = 'Zwiń podmenu dla ';

    function getTriggers() {
        return nav.querySelectorAll( '.menu__item--has-children > [aria-controls]' );
    }

    function getItemTitle( el ) {
        const label = el.getAttribute( 'aria-label' ) || '';
        return label.replace( labelExpand, '' ).replace( labelCollapse, '' );
    }

    function setExpanded( el, expanded ) {
        const title = getItemTitle( el );
        el.setAttribute( 'aria-expanded', String( expanded ) );
        el.setAttribute( 'aria-label', ( expanded ? labelCollapse : labelExpand ) + title );
    }

    function closeAllExcept( exceptEl ) {
        getTriggers().forEach( ( el ) => {
            if ( el !== exceptEl && el.getAttribute( 'aria-expanded' ) === 'true' ) {
                setExpanded( el, false );
            }
        } );
    }

    nav.addEventListener( 'click', ( e ) => {
        const control = e.target.closest( '.menu__item--has-children > [aria-controls]' );
        if ( ! control ) return;
        e.preventDefault();
        const expanded = control.getAttribute( 'aria-expanded' ) === 'true';
        closeAllExcept( control );
        setExpanded( control, ! expanded );
    } );

    nav.addEventListener( 'keydown', ( e ) => {
        const control = e.target.closest( '.menu__item--has-children > [aria-controls]' );
        if ( ! control ) return;
        if ( e.key === 'Enter' || e.key === ' ' ) {
            e.preventDefault();
            const expanded = control.getAttribute( 'aria-expanded' ) === 'true';
            closeAllExcept( control );
            setExpanded( control, ! expanded );
        }
    } );

    document.addEventListener( 'keydown', ( e ) => {
        if ( e.key !== 'Escape' ) return;
        const open = nav.querySelector( '[aria-controls][aria-expanded="true"]' );
        if ( open ) {
            setExpanded( open, false );
            open.focus();
        }
    } );
}
